import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

import { UnifiedPromptuaryService } from '../promptuary-form/unified-promptuary.service';

@Component({
	selector: 'promptuary-service-evolution',
	templateUrl: './promptuary-service-evolution.component.html',
	styleUrls: ['./promptuary-service-evolution.component.scss'],
})
export class PromptuaryServiceEvolutionComponent {
	constructor(
		public unifiedPromptuary: UnifiedPromptuaryService,
		public promptuaryService: PromptuaryService
	) {}

	@Input()
	autoSaveData;
	@Input()
	formGroup: FormGroup;

	@Input()
	showSpeechToText: boolean;

	@Input()
	showQuality: boolean;

	@Input()
	appointment;

	onPromptuaryEvolutionSaving() {
		this.unifiedPromptuary.serviceEvolutionQuality = 'loading';
		if (this.unifiedPromptuary.autosaveLoading.includes('serviceEvolution')) {
			return;
		}
		this.unifiedPromptuary.setAutoSaveLoading('serviceEvolution');
	}

	onPromptuaryEvolutionSaved() {
		this.unifiedPromptuary.autosaveComplete('serviceEvolution');
		this.getServiceEvolutionQuality();
	}

	getServiceEvolutionQuality() {
		if (
			this.unifiedPromptuary.form.get('serviceEvolution')?.value?.length === 0
		) {
			this.unifiedPromptuary.serviceEvolutionQuality = 'default';
			return;
		}
		this.promptuaryService
			.getServiceEvolutionQuality(
				this.unifiedPromptuary.form.get('serviceEvolution').value
			)
			.subscribe(
				(res) =>
					(this.unifiedPromptuary.serviceEvolutionQuality = res.isApproved
						? 'approved'
						: 'declined')
			);
	}
}
